import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "d39954xg51HdKfjOGWM3+if", "Vibrate", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, v2, game, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var E_VibrateType;

(function (E_VibrateType) {
  E_VibrateType[E_VibrateType["Normal"] = 0] = "Normal";
  E_VibrateType[E_VibrateType["Decrease"] = 1] = "Decrease";
})(E_VibrateType || (E_VibrateType = {}));

var Vibrate = (_dec = menu("act/vibrate"), _dec2 = property({
  type: Enum(E_VibrateType),
  tooltip: "振动方式: \n Normal: 正常幅度振动 \n Decrease: 递减模式振动"
}), _dec3 = property({
  tooltip: "振动时间"
}), _dec4 = property({
  tooltip: "振动幅度"
}), _dec5 = property({
  tooltip: "振动强度: 1 - 10   依次递增",
  min: 1,
  max: 10
}), _dec6 = property({
  tooltip: "是否加载后，直接播放"
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Vibrate, _Component);

  function Vibrate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "time", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "range", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "power", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isPlayedOnLoad", _descriptor5, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isAct", false);

    _defineProperty(_assertThisInitialized(_this), "_curTime", 0);

    _defineProperty(_assertThisInitialized(_this), "_minRange", 1);

    _defineProperty(_assertThisInitialized(_this), "_curRange", 0);

    _defineProperty(_assertThisInitialized(_this), "_rangeRadio", 0);

    _defineProperty(_assertThisInitialized(_this), "_curPower", 0);

    _defineProperty(_assertThisInitialized(_this), "_power", {
      1: 19,
      2: 17,
      3: 15,
      4: 13,
      5: 11,
      6: 9,
      7: 7,
      8: 5,
      9: 3,
      10: 1
    });

    _defineProperty(_assertThisInitialized(_this), "_initPos", null);

    _defineProperty(_assertThisInitialized(_this), "_curPos", v2());

    return _this;
  }

  var _proto = Vibrate.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {
    this._initPos = v2(this.node.position.x, this.node.position.y);
  };

  _proto.start = function start() {
    if (this.isPlayedOnLoad) {
      this.act();
    }
  };

  _proto.getV = function getV(index) {
    var prototype = Object.getPrototypeOf(this._power);
    var info = Object.getOwnPropertyDescriptor(prototype, index);
    return info.value;
  };

  _proto.act = function act() {
    if (!this._initPos) {
      this._initPos = v2(this.node.position.x, this.node.position.y);
    }

    switch (this.type) {
      case E_VibrateType.Normal:
        this._isAct = true;
        this._curTime = this.time;
        this._curPower = this.getV(this.power.toString());
        break;

      case E_VibrateType.Decrease:
        this._isAct = true;
        this._curTime = this.time;
        this._curPower = this.getV(this.power.toString());
        this._curRange = this.range;
        this._rangeRadio = (this._curRange - this._minRange) / (this.time * game.getFrameRate() / this._curPower);
        break;
    }
  };

  _proto.update = function update(dt) {
    if (this._isAct) {
      this._curTime -= dt;

      if (this._curPower > 0) {
        this._curPower--;
      } else if (this._curTime > 0) {
        switch (this.type) {
          case E_VibrateType.Normal:
            var tx = Math.random() * this.range;
            tx = tx < this.range / 2 ? this.range / 2 : tx;
            var ty = Math.random() * this.range;
            ty = ty < this.range / 2 ? this.range / 2 : ty;
            this._curPos = this._initPos.add(v2(tx, ty));
            this.node.setPosition(v3(this._curPos.x, this._curPos.y));
            break;

          case E_VibrateType.Decrease:
            this._curPos = this._initPos.add(v2(Math.random() * this._curRange, Math.random() * this._curRange));
            this.node.setPosition(v3(this._curPos.x, this._curPos.y));
            this._curRange -= this._rangeRadio;
            this._curRange = this._curRange <= this._minRange ? this._minRange : this._curRange;
            break;
        }

        this._curPower = this.getV(this.power.toString());
      } else {
        this._isAct = false;
        this.node.setPosition(v3(this._initPos.x, this._initPos.y));
      }
    }
  };

  return Vibrate;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_VibrateType.Normal;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "time", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "range", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 2;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "power", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 3;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isPlayedOnLoad", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class);
export { Vibrate as default };

_cclegacy._RF.pop();